module.exports = __webpack_public_path__ + "static/media/IdentityVerification.838a5983.svg";